module.exports = __webpack_public_path__ + "img/banff-centre.a6c34954.png";